import React from "react";
import "./css/header.css";
import { Button } from "primereact/button";
const Header = ({ isPermitted, handleCreateTemplate }) => {
  return (
    <header className="main-header-report-screen">
      <div className="header-content">
        <h1>Report Template</h1>

        <p>
          {" "}
          Create and manage custom templates to download data in your preferred
          format. Below is a list of your saved templates.
        </p>
      </div>
      <Button
        disabled={!isPermitted("/create-template")}
        label="Create Template"
        onClick={handleCreateTemplate}
        className="nextbtn"
      />
    </header>
  );
};

export default Header;
